import { apiRequest } from "../services/apiRequest"

export const Product = {
  getProductList: async (data, page) => {
    const params = new URLSearchParams()

    if (data?.store_id) params.append("store_id", data.store_id)
    if (data?.category) params.append("category", data.category)
    if (data?.is_active !== undefined && data?.is_active !== "")
      params.append("is_active", data.is_active)
    if (data?.name_english) params.append("name_english", data.name_english)
    if (page) params.append("page", page)

    const queryString = params.toString()
    const url = `/api/product/?${queryString}`

    return await apiRequest("get", url, undefined, { skipCache: true })
  },
  addProduct: async (data) => await apiRequest("post", `/api/product/`, data),
  updateProduct: async (data, productId) =>
    await apiRequest("put", `/api/product/${productId}/`, data),
  deleteProduct: async (data) =>
    await apiRequest("delete", `/api/product/destroy_multiple/`, data),

  //Get Uploaded File
  getUploadedFiles: async (data) =>
    await apiRequest("get", `/api/get-products-file/?store=${data}`),
  deleteUploadedFile: async (data) =>
    await apiRequest("delete", `/api/delete-products-file/`, data),
}
